import { api } from '@/api'

export interface ServiceRegion {
  id: string
  name: string
  code: string
  isActive: boolean
}

export interface ServiceRegionOption extends ServiceRegion {
  label: string
  value: string
}

export interface ServiceRegionsFilters {
  page?: number
  [key: string]: string | number | boolean | undefined | null
}

export interface ServiceRegionsResponse {
  data: ServiceRegion[]
  meta: {
    message: string
    errors: unknown[]
  }
  pagination?: {
    currentPage: number
    perPage: number
    total: number
    lastPage: number
    from: number | null
    to: number | null
  }
}

export function getServiceRegionsAction(filters: ServiceRegionsFilters = {}) {
  const params = new URLSearchParams()

  if (filters.page) {
    params.append('page', String(filters.page))
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && key !== 'page') {
      params.append(`filter[${key}]`, String(value))
    }
  })

  const query = params.toString()

  return api.v2.get<ServiceRegionsResponse>(`/regions${query ? `?${query}` : ''}`)
}
